import { render, staticRenderFns } from "./ResourcesTeaminfo.vue?vue&type=template&id=7642bb45&"
import script from "./ResourcesTeaminfo.vue?vue&type=script&lang=js&"
export * from "./ResourcesTeaminfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports